import { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import './LanguageSwitcher.css';

const LANGUAGES = [
  { code: 'en', label: 'EN', flagSrc: '/img/usaFlag.png', aria: 'English' },
  { code: 'es', label: 'ES', flagSrc: '/img/argenFlag.png', aria: 'Spanish' },
  { code: 'pt', label: 'PT', flagSrc: '/img/brazilFlag.png', aria: 'Portuguese' },
];

function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const current = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];
  const others = LANGUAGES.filter((l) => l.code !== language);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    setLanguage(code);
    setOpen(false);
  };

  return (
    <div
      className="language-switcher language-switcher--dropdown"
      ref={containerRef}
      role="group"
      aria-label="Select language"
    >
      <button
        type="button"
        className="language-switcher__trigger"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={`Language: ${current.aria}. Click to change`}
      >
        <span className="language-switcher__flag-circle" aria-hidden="true">
          <img src={current.flagSrc} alt="" className="language-switcher__flag-img" />
        </span>
        <span className="language-switcher__label">{current.label}</span>
      </button>
      {open && (
        <ul
          className="language-switcher__dropdown"
          role="listbox"
          aria-label="Choose language"
        >
          {others.map(({ code, label, flagSrc, aria }) => (
            <li key={code} role="option" aria-selected={false}>
              <button
                type="button"
                className="language-switcher__option"
                onClick={() => handleSelect(code)}
                aria-label={`${aria} (${label})`}
              >
                <span className="language-switcher__option-flag">
                  <img src={flagSrc} alt="" className="language-switcher__flag-img" />
                </span>
                <span>{label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;
